const columns = () => [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
  },
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    key: 'timestamp',
    width: 180,
  },
  {
    title: 'Service',
    dataIndex: 'serviceName',
    key: 'serviceName',
    width: 140,
  },
  {
    title: 'Method',
    dataIndex: 'method',
    key: 'method',
    width: 80,
  },
  {
    title: 'Endpoint',
    dataIndex: 'endpoint',
    key: 'endpoint',
    ellipsis: true,
  },
  {
    title: 'Status',
    dataIndex: 'statusCode',
    key: 'statusCode',
    width: 80,
  },
  {
    title: 'Error',
    dataIndex: 'errorMessage',
    key: 'errorMessage',
    ellipsis: true,
  },
  {
    title: 'User ID',
    dataIndex: 'userId',
    key: 'userId',
    width: 80,
  },
  {
    title: 'Duration',
    dataIndex: 'durationMs',
    key: 'durationMs',
    width: 90,
  },
  {
    title: 'Resolved',
    dataIndex: 'isResolved',
    key: 'isResolved',
    width: 100,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 120,
    fixed: 'right',
  },
];

export default columns;
